function Icon({ icon, iconType = "fa-regular" }) {
	return <i className={`${iconType} ${icon}`}></i>;
}

export default Icon;
